import { Button, HStack, Stack, Text, useToast } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { adminMeilisearchAutoCompleteSetup, adminMeilisearchFullSetup, adminMeilisearchReIndex, adminMeilisearchUpdateSettings } from "../../../api";
import AdminOnly from "../../../components/Auth/AdminOnly";
import { colors } from "../../../styles";

export default function MeiliSearch() {

    /* toast */

    const toast = useToast();

    /* mutation */

    const meilisearchSetupMutation = useMutation({
        mutationFn: adminMeilisearchFullSetup,
        onSuccess: () => {
            toast({
                title: "meilisearch setup 성공",
                status: "success",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
        onError: (error: any) => {
            toast({
                title: `${error.response?.data?.message}`,
                status: "error",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    const meilisearchUpdateSettingsMutation = useMutation({
        mutationFn: adminMeilisearchUpdateSettings,
        onSuccess: () => {
            toast({
                title: "meilisearch update settings 성공",
                status: "success",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
        onError: (error: any) => {
            toast({
                title: `${error.response?.data?.message}`,
                status: "error",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    const meilisearchReIndexMutation = useMutation({
        mutationFn: adminMeilisearchReIndex,
        onSuccess: () => {
            toast({
                title: "meilisearch reIndex 성공",
                status: "success",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
        onError: (error: any) => {
            toast({
                title: `${error.response?.data?.message}`,
                status: "error",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    const meilisearchAutoCompleteSetupMutation = useMutation({
        mutationFn: adminMeilisearchAutoCompleteSetup,
        onSuccess: () => {
            toast({
                title: "meilisearch auto-complete setup 성공",
                status: "success",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
        onError: (error: any) => {
            toast({
                title: `${error.response?.data?.message}`,
                status: "error",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    /* render */

    return (
        <AdminOnly>
            <Stack width={"100%"} padding={10}>

                {/* title */}

                <HStack justifyContent={"space-between"} alignItems={"center"} gap={10}>
                    <Text fontSize={28} fontWeight={700} color={colors.black}>meilisearch setup</Text>
                </HStack>

                {/* buttons */}

                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={10} marginTop={10}>
                    <Button
                        width={"200px"}
                        height={"200px"}
                        backgroundColor={colors.white}
                        borderColor={colors.blue}
                        borderWidth={1}
                        borderRadius={10}
                        _hover={{ bg: colors.light }}
                        boxShadow="sm"

                        onClick={() => meilisearchSetupMutation.mutate()}
                        isLoading={meilisearchSetupMutation.isPending}
                    >
                        <Text fontSize={18} fontWeight={700} color={colors.black}>search setup</Text>
                    </Button>
                    <Text fontSize={18} fontWeight={700} color={colors.black}>=</Text>
                    <Button
                        width={"200px"}
                        height={"200px"}
                        backgroundColor={colors.white}
                        borderColor={colors.blue}
                        borderWidth={1}
                        borderRadius={10}
                        _hover={{ bg: colors.light }}
                        boxShadow="sm"

                        onClick={() => meilisearchUpdateSettingsMutation.mutate()}
                        isLoading={meilisearchUpdateSettingsMutation.isPending}
                    >
                        <Text fontSize={18} fontWeight={700} color={colors.black}>1️⃣ update settings</Text>
                    </Button>
                    <Text fontSize={18} fontWeight={700} color={colors.black}>+</Text>
                    <Button
                        width={"200px"}
                        height={"200px"}
                        backgroundColor={colors.white}
                        borderColor={colors.blue}
                        borderWidth={1}
                        borderRadius={10}
                        _hover={{ bg: colors.light }}
                        boxShadow="sm"

                        onClick={() => meilisearchReIndexMutation.mutate()}
                        isLoading={meilisearchReIndexMutation.isPending}
                    >
                        <Text fontSize={18} fontWeight={700} color={colors.black}>2️⃣ reIndex</Text>
                    </Button>
                </HStack>

                {/* auto-complete setup */}
                <HStack justifyContent={"flex-start"} alignItems={"center"} gap={10} marginTop={10}>
                    <Button
                        width={"200px"}
                        height={"200px"}
                        backgroundColor={colors.white}
                        borderColor={colors.blue}
                        borderWidth={1}
                        borderRadius={10}
                        _hover={{ bg: colors.light }}
                        boxShadow="sm"

                        onClick={() => meilisearchAutoCompleteSetupMutation.mutate()}
                        isLoading={meilisearchAutoCompleteSetupMutation.isPending}
                    >
                        <Text fontSize={18} fontWeight={700} color={colors.black}>auto-complete setup</Text>
                    </Button>
                </HStack>
            </Stack>
        </AdminOnly>
    );
}